import { DateRange, LhChange } from "@liebherr/patternlib";
import { PatternlibDatepickerCustomEvent } from "@liebherr/patternlib/dist/types/components";
import PLDatepicker from "components/patternLib/form/PLDatepicker";
import React from "react";
import { useSetRecoilState } from "recoil";
import { dateRangeForDatagridTable } from "./recoilState";

const DateRangeFilter = () => {
  const now = new Date().toISOString();
  const setDateRange = useSetRecoilState(dateRangeForDatagridTable);
  const handleDate = (event: PatternlibDatepickerCustomEvent<LhChange>) => {
    const value = event.detail.value as DateRange;
    if (!value) return setDateRange(undefined);
    setDateRange([value.start as string, value.end as string]);
  };

  return <PLDatepicker dateRange width="300px" maximumDate={now} lhChange={handleDate} />;
};

export default DateRangeFilter;
